// X.2 (klient z ulicy): rezerwacja wymaga e-maila ALBO telefonu, nie obu. Ta sama reguła co
// POST /api/reservation (Login/backend/routes/reservations.js), więc panel odrzuca dokładnie to,
// co odrzuciłby serwer. Czyste funkcje bez Reacta; tekst komunikatu dobiera ekran po kluczu.

const tekst = (v) => String(v ?? '').trim();

// Jeden adres z kropką w domenie, bez spacji i znaków rozdzielających listę adresów; apostrof
// w części lokalnej dozwolony. LUSTRO Login/backend/lib/transportFirmy.js#EMAIL_ODBIORCY (zgodność
// pilnuje utils/__tests__/kontaktKlienta.test.js). Dawny wzorzec bez kotwic przepuszczał
// „jan kowalski@wp.pl”, a wysyłka czytała z niego „kowalski@wp.pl”, czyli adres obcej osoby.
export const EMAIL_KLIENTA = /^[^\s@<>",;:()[\]\\]+@[^\s@<>"',;:()[\]\\]+\.[^\s@<>"',;:()[\]\\]+$/;

/** Czy tekst pola to jeden poprawny adres e-mail (po przycięciu spacji). */
export function emailPoprawny(v) {
  const s = tekst(v);
  return s.length <= 254 && EMAIL_KLIENTA.test(s);
}

export function maKontakt({ email, phone } = {}) {
  return !!tekst(email) || !!tekst(phone);
}

// Błędy pól kontaktu jako klucze tłumaczeń. Brak obu kontaktów zaznacza oba pola, bo każde
// z nich naprawia błąd; e-mail sprawdzany jest tylko, gdy ktoś go wpisał.
export function bledyKontaktu({ email, phone } = {}) {
  const adres = tekst(email);
  if (!adres && !tekst(phone)) {
    return { email: 'reservation.contactRequired', phone: 'reservation.contactRequired' };
  }
  if (adres && !emailPoprawny(adres)) return { email: 'validation.invalidEmail' };
  return {};
}
